(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/gaming-account-info.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/gaming-account-info.js');
"use strict";


const {
  ReactIcon: Icon
} = svs.ui;
setGlobal('svs.ticketsValidate.components.GamingAccountInfo', () => {
  const infoRef = React.useRef(null);
  const onInfoClicked = e => {
    e === null || e === void 0 || e.preventDefault();
    const dialog = new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo: infoRef.current,
      title: 'Spelkonto',
      message: [{
        align: svs.ui.dialog.message.align.LEFT,
        type: svs.ui.dialog.message.TEXT,
        text: 'För att kunna köpa lotter digitalt och spela spel hos Svenska Spel har du ett spelkonto. Detta för att vi ska kunna säkerställa din identitet och att du är över 18 år gammal, vilket är ett krav för att du ska få spela. Det är också på spelkontot som dina spelvinster sätts in.'
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  return React.createElement("div", {
    className: "u-flex padding-top-1"
  }, React.createElement(Icon, {
    className: "margin-right-1 margin-top-half",
    icon: "information",
    size: "300"
  }), React.createElement("span", {
    className: "f-400 align-left",
    "data-testid": "gaming-account-info"
  }, "Om du inte tar ut hela din vinst i lotter kommer resten av pengarna att finnas kvar p\xE5 ditt", React.createElement("a", {
    onClick: onInfoClicked,
    ref: infoRef
  }, ' ', "spelkonto"), ". All information om dina vinster hittar du i Mina spel."));
});

 })(window);